export default __webpack_public_path__ + "static/media/default_icon_leko.84dbaeee.svg";